import { createJSONStorage, type StateStorage } from 'zustand/middleware'

// Zustand keeps live state in memory. Persistence must not interrupt an action
// when browser storage is blocked or full.
const storage: StateStorage = {
  getItem: (name) => {
    try { return localStorage.getItem(name) } catch { return null }
  },
  setItem: (name, value) => {
    try { localStorage.setItem(name, value) } catch {
      // Do not restore an outdated session/draft after a failed write.
      storage.removeItem(name)
    }
  },
  removeItem: (name) => {
    try { localStorage.removeItem(name) } catch { /* memory state still works */ }
  },
}

export const createPersistentStorage = <T>() => createJSONStorage<T>(() => storage)
